// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__3PJVi","success":"AnswerItem_success__30eEE","error":"AnswerItem_error___hrWf"};